import { FC } from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

type StepNavProps = {
    onBack?: () => void;
    onNext?: () => void;
    backLabel?: string;
    nextLabel?: string;
    nextDisabled?: boolean;
    hideBack?: boolean;
    nextType?: 'button' | 'submit';
};

export const StepNav: FC<StepNavProps> = ({
    onBack,
    onNext,
    backLabel,
    nextLabel,
    nextDisabled = false,
    hideBack = false,
    nextType = 'button',
}) => {
    const { t } = useTranslation();

    return (
        <div className="mpc-step-nav">
            {!hideBack && (
                <Button
                    type="button"
                    variant="outlined"
                    className="mpc-btn-ghost"
                    onClick={onBack}
                    disabled={!onBack}
                >
                    {backLabel || t('mobileProductCapture.nav.back')}
                </Button>
            )}
            <Button
                type={nextType}
                variant="contained"
                className={`mpc-btn-primary${hideBack ? ' mpc-btn-primary--full' : ''}`}
                onClick={nextType === 'button' ? onNext : undefined}
                disabled={nextDisabled || (!onNext && nextType === 'button')}
            >
                {nextLabel || t('mobileProductCapture.nav.next')}
            </Button>
        </div>
    );
};
